import actions from './actions';

const initialState = {
  isSearching: false,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
};

export default function cmsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CREATE_CMS:
    case actions.CREATE_CMS_CATEGORY:
      return {
        ...state,
        isCreating: true,
      };
    case actions.CREATE_CMS_END:
    case actions.CREATE_CMS_CATEGORY_END:
      return {
        ...state,
        isCreating: false,
      };
    case actions.SEARCH_CMS:
    case actions.FIND_CMS:
    case actions.SEARCH_CMS_CATEGORY:
    case actions.FIND_CMS_CATEGORY:
      return {
        ...state,
        isSearching: true,
      };
    case actions.SEARCH_CMS_END:
    case actions.FIND_CMS_END:
    case actions.SEARCH_CMS_CATEGORY_END:
    case actions.FIND_CMS_CATEGORY_END:
      return {
        ...state,
        isSearching: false,
      };
    case actions.UPDATE_CMS:
    case actions.UPDATE_CMS_CATEGORY:
      return {
        ...state,
        isUpdating: true,
      };
    case actions.UPDATE_CMS_END:
    case actions.UPDATE_CMS_CATEGORY_END:
      return {
        ...state,
        isUpdating: false,
      };
    case actions.DELETE_CMS:
    case actions.DELETE_CMS_CATEGORY:
      return {
        ...state,
        isDeleting: true,
      };
    case actions.DELETE_CMS_END:
    case actions.DELETE_CMS_CATEGORY_END:
      return {
        ...state,
        isDeleting: false,
      };
    default:
      return state;
  }
}
